import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: true,
    imports: [NgClass, TranslateModule, NgOptimizedImage],
})
export class LoaderComponent {
    @Input() overlay: boolean = false;
    @Input() globalLoader: boolean = false;
    @Input() customText = '';
}
